import { ITextButton } from "@/components/atoms/buttons/types";

export const callCtaSectionData: {
  heading: string;
  description: string;
  buttons: ITextButton[];
} = {
  heading: "Take complete control of your cybersecurity",
  description:
    "Get free guidance from certified experts or build tailored strategies with our team now.",
  buttons: [
    {
      variant: "yellow",
      text: "Book a Discovery Call",
      link: "/",
      id: "call-cta-request-call-button",
    },
    {
      variant: "outline",
      text: "Access my business",
      link: "/",
      id: "call-cta-access-business-button",
    },
  ],
};
